// ==========================
// Version 4 — Footer.js (legal operator disclosure)
// ==========================
import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="bwak-footer" role="contentinfo">
      <div className="bwak-footer__inner">
        {/* Brand */}
        <div className="bwak-footer__brand" aria-label="Blessed with a Kiss">
          <BrandLogo
            size={32}
            decorative
            style={{
              borderRadius: 10,
              padding: 2,
              border: '1px solid rgba(253,252,249,0.15)',
            }}
          />
          <span>Blessed with a Kiss</span>
        </div>

        {/* Right block: nav + notes */}
        <div style={{ textAlign: 'right' }}>
          <nav aria-label="Footer links">
            <ul style={ulReset}>
              <li><Link to="/map">Global Map</Link></li>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
            </ul>
          </nav>

          <div className="bwak-footer__note">© {year} Blessed with a Kiss</div>
          <div className="bwak-footer__note">
            Operated by Afrooz Innovations Ltd, company no. 17080521, registered in England and Wales.
          </div>
          <div className="bwak-footer__note">Your story. Your proof. Forever.</div>
        </div>
      </div>
    </footer>
  );
}

const ulReset = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  gap: 10,
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
};
// ==========================
// End Version 4 — Footer.js
// ==========================
